export default __webpack_public_path__ + "a6ffcfda68952dab9d40e0e0b9faa409.jpg";